import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, PenLine } from 'lucide-react';
import { rewriterTones } from '../../../data/rewriterTones';

/** Free engagement path after a scan. Deliberately quieter than the report CTA. */
export function NeedHelpRespondingCard() {
  return <section aria-labelledby="rewriter-heading" className="flex flex-col gap-5 border-t border-forensic-line pt-10 sm:flex-row sm:items-center sm:justify-between" data-id="element-257" data-mp="1qsxgxuy327o6">
      <div className="flex items-start gap-4" data-id="element-258" data-mp="1h2mcm7ahlwgr">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-forensic-card" data-id="element-259" data-mp="1h1t34yk58sux">
          <PenLine size={18} className="text-forensic-muted" aria-hidden="true" data-id="element-260" data-mp="1d1ix5lwcq2g2" />
        </span>
        <div data-id="element-261" data-mp="1837qtl59ma2l">
          <h2 id="rewriter-heading" className="text-base font-semibold text-white" data-id="element-262" data-mp="183r58rvpigbv">
            Need help responding?
          </h2>
          <p className="mt-1 text-sm text-forensic-muted" data-id="element-263" data-mp="y3qmp85nw48q">
            Transform an emotionally charged message into a{' '}
            {rewriterTones.map((tone, i) => <span key={tone} data-id="element-264" data-mp="gprjgbj7cwcw" data-mpi={i}>
                <span className="text-gray-200" data-id="element-265" data-mp="liazrg99y5le">{tone}</span>
                {i < rewriterTones.length - 2 ? ', ' : i === rewriterTones.length - 2 ? ', or ' : ''}
              </span>)}{' '}
            reply.
          </p>
          <p className="mt-2 text-xs text-forensic-subtle" data-id="element-266" data-mp="btjaxgzig1ep">You have 3 free rewrites today</p>
        </div>
      </div>
      <Link to="/tools/rewriter" className="inline-flex min-h-[44px] shrink-0 items-center justify-center gap-2 rounded-xl border border-forensic-line-strong px-5 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-white/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-forensic-crimson-soft" data-id="element-267" data-mp="zivkihyr2bhj">
        Open Rewriter
        <ArrowRight size={15} aria-hidden="true" data-id="element-268" data-mp="3a9lxpwd3v1wq" />
      </Link>
    </section>;
}